import {takeLatest, call, put} from 'redux-saga/effects'
import {
  SETTING_PUBLIC_PROFILE_PAGE_REQUEST,
  SETTING_PUBLIC_PROFILE_REQUEST
} from 'actions/setting/publicProfile/constants'
import {getProfile} from 'api/profile'
import {initialize} from 'redux-form'
import * as action from 'actions'
import {phoneNumberFormatter} from 'utils/formatter'
import {settingPublicProfile} from 'api/publicProfile'
import * as actNotif from 'actions/notifications'
import * as mpSettingPublicProfile from 'mixpanel/settings/publicProfile'

export function * publicProfilePageRequestFlow () {
  try {
    mpSettingPublicProfile.settingPublicProfileStart()
    yield put(action.sendingRequest(true))
    yield put(action.showProgressBar())
    let resProfile = yield call(getProfile)
    let profile = resProfile.data
    yield put(action.setProfile(profile))
    // set initial value of public profile form at first load
    yield put(initialize('publicProfileForm', {
      'gravatar': profile.gravatar,
      'name': profile.business.name,
      'description': profile.business.description,
      'address': profile.business.address,
      'city': profile.business.city,
      'province': profile.business.province,
      'postal_code': profile.business.postal_code,
      'phone': profile.business.phone ? phoneNumberFormatter(profile.business.phone) : '',
      'email': profile.business.email,
      'website': profile.business.website,
      'twitter': profile.business.twitter,
      'facebook': profile.business.facebook,
      'instagram': profile.business.instagram
    }))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(action.sendingRequest(false))
    yield put(action.hideProgressBar())
  }
}

export function * publicProfileRequestFlow (request) {
  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())
  let {values: {gravatar, name, description, address, city, province, postal_code, phone, email, website, twitter, facebook, instagram}, user: profile} = request.payload.data
  let businessId = profile.business.id
  let business = profile.business
  let data = {
    business: {
      id: businessId,
      name: name,
      description: description,
      address: address,
      city: city,
      province: province,
      postal_code: postal_code,
      phone: '0' + phone,
      email: email,
      website: website,
      twitter: twitter,
      facebook: facebook,
      instagram: instagram,
      logo: {url: gravatar},
      suite: business.suite,
      notify_per_deposit: business.notify_per_deposit,
      notify_per_trans: business.notify_per_trans,
      user_id: business.user_id,
      is_deleted: business.is_deleted,
      created_at: business.created_at,
      updated_at: business.updated_at,
      business_type_id: business.business_type_id,
      business_category_id: business.business_category_id,
      notes: business.notes,
      latitude: business.latitude,
      longitude: business.longitude,
      synchronized_at: business.synchronized_at,
      outlet_slot: business.outlet_slot,
      is_trial: business.is_trial,
      current_plan: business.current_plan,
      expired_at: business.expired_at,
      last_payment_date: business.last_payment_date,
      trial_end_at: business.trial_end_at,
      setting: business.setting
    }
  }
  // https://mokapos.atlassian.net/browse/FD-1720
  // somehow backend bakal rusak kalo dia upload remote_logo_url tapi sama dengan yang sebelumnya
  // jadi hanya kirim remote_logo kalo beda dengan sebelumnya
  // wasting time amat
  let gravatarChanged = gravatar === ''
  if (business.logo) {
    gravatarChanged = gravatarChanged || business.logo.url !== gravatar
  } else {
    gravatarChanged = !(gravatar)
  }
  if (gravatarChanged) {
    data.business.remote_logo_url = gravatar
    data.business.remove_logo = gravatar === ''
  }
  try {
    yield call(settingPublicProfile, businessId, data)
    let resProfile = yield call(getProfile)
    let profile = resProfile.data
    yield put(action.setProfile(profile))
    // set initial value of public profile after submitting form
    yield put(initialize('publicProfileForm', {
      'gravatar': gravatar,
      'name': name,
      'description': description,
      'address': address,
      'city': city,
      'province': province,
      'postal_code': postal_code,
      'phone': phoneNumberFormatter('0' + phone),
      'email': email,
      'website': website,
      'twitter': twitter,
      'facebook': facebook,
      'instagram': instagram
    }))
    yield put(actNotif.success('Business successfully edited.'))
  } catch (error) {
    yield put(actNotif.error(error.message))
    return false
  } finally {
    yield put(action.hideProgressBar())
    yield put(action.sendingRequest(false))
  }
}

export default function * settingPublicProfileSaga () {
  yield takeLatest(SETTING_PUBLIC_PROFILE_PAGE_REQUEST, publicProfilePageRequestFlow)
  yield takeLatest(SETTING_PUBLIC_PROFILE_REQUEST, publicProfileRequestFlow)
}



// WEBPACK FOOTER //
// ./app/sagas/setting/publicProfile.js